function useFilter(state, setState, storageItem, filterArgs) {
  const setStorage = filterArg => {
    setState(filterArg);
    localStorage.setItem(storageItem, filterArg);
  };

  const dropdownActions = filterArgs.map(filterArg => ({
    name: filterArg,
    action: () => setStorage(filterArg),
    disabled: state === filterArg
  }));

  return dropdownActions;
}

export default useFilter;



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/useFilter.js